
import { createStore } from 'vuex';
import auth from './authStore.js';
import template from './templateStore.js';
import documents from './documentStore.js';
import importaciones from './importaciones.js';
import userdata from './userdataStore.js';
import membership from './membershipStores.js';
import helper from './helperStore.js';
import leads from './leadStore.js';
import pqr from './pqrStore.js';
import credentialPortal from './credentialPortalStore.js';
import externalCredential from './externalCredentialStore.js';
import plans from './planStore.js';
import lonjas from './lonjaStore.js';
import aiUsage from './aiUsageStore.js';
import properties from './propertyStore.js';
import wasi from './wasiStore.js';
import localidades from './localidadStore.js';
import roles from './rolStore.js';
import plataforma from './plataformaStore.js';
import reputacionInmuebles from './reputacionInmueblesStore.js';
import negociosPlataforma from './negociosPlataformaStore.js';



const store = createStore({

    modules: {
        'appAuth': auth,
        'appTemplate':template,
        'appDocuments': documents,
        'importaciones': importaciones,
        'appUserdata': userdata,
        'appMembership': membership,
        'appHelpers': helper,
        'appLeads': leads,
        'appPQR': pqr,
        'appCredentialPortal': credentialPortal,
        'appExternalCredentials': externalCredential,
        'appPlans': plans,
        'appLonjas': lonjas,
        'appAiUsage': aiUsage,
        'appProperties': properties,
        'appWasi': wasi,
        'appLocalidades': localidades,
        'appRoles': roles,
        'appPlataforma': plataforma,
        'appReputacionInmuebles': reputacionInmuebles,
        'appNegociosPlataforma': negociosPlataforma
    }
});

export default store;


